import { Model } from 'json-api-models';
import { orderBy } from 'lodash-es';

import { Models, Schemas } from '../models.ts';

export class PresentationQuestion extends Model<Schemas['presentationQuestions'], Models> {
    get popularAnswers() {
        const numCorrect =
            this.questionAttempt?.question?.activeRevision?.correctOptions.length || 1;

        const optionVotes = Object.entries(this.optionVotes || {}).filter(([, v]) => v);

        return orderBy(optionVotes, '1', 'desc')
            .slice(0, numCorrect)
            .map(([i]) => i);
    }
}
